import * as angular from "angular";
import {IController} from "angular";

export class BringozDatesTimeRangeComponent implements IController {
  from: any;
  to: any;
  timeOnly: boolean;
  hideDate?: boolean;
  hideToTime?: boolean;
  dateOnly: any;
  zoneId?: string;
  isRow?: boolean;
  ticks?: number;
  fromPlaceholder: string;
  toPlaceholder: string;
  isIgnoreTimezoneOffsetDiff: boolean;
  onRangeChange: Function;

  public timeConfig: any;
  public isInvalidDates: boolean;

  constructor(private moment) {
  }

  $onInit() {

    if (!this.ticks) {
      this.ticks = 15;
    }

    this.setConfig(this.from, this.to);
  }

  $onChanges(changes) {
    if (changes.from && !changes.from.isFirstChange()) {
      this.setConfig(this.from, this.to);
    }
    if (changes.to && !changes.to.isFirstChange()) {
      this.setConfig(this.from, this.to);
    }
  }

  onFromDateChange(from) {
    let fromDateMomentRef = this.moment(from);
    let day = fromDateMomentRef.date(),
      month = fromDateMomentRef.month(),
      year = fromDateMomentRef.year();

    this.timeConfig.from.value = this.moment(this.timeConfig.from.value).set({
      'year': year,
      'month': month,
      'date': day
    }).valueOf();
    if (this.timeConfig.from.date >= this.timeConfig.to.date) {
      this.timeConfig.to.date = this.moment(from).toDate();
      this.timeConfig.to.value = this.moment(from).endOf('day').set({
        'minute': 45,
        'second': 0,
        'millisecond': 0
      }).valueOf();
    }

    this.onRangeChange({from: this.timeConfig.from.value, to: this.timeConfig.to.value})
  }

  onFromTimeChange(time) {
    this.timeConfig.from.value = time;
    this.onRangeChange({from: this.timeConfig.from.value, to: this.timeConfig.to.value})
  }

  onToDateChange(date) {
    this.timeConfig.to.date = this.moment(date).endOf('day').toDate();
    this.timeConfig.to.value = this.moment(date).set({
      hour: this.moment(this.timeConfig.to.value).hours(),
      minute: this.moment(this.timeConfig.to.value).minutes(),
      second: this.moment(this.timeConfig.to.value).seconds()
    }).valueOf();
    this.onRangeChange({from: this.timeConfig.from.value, to: this.timeConfig.to.value})
  }

  onToTimeChange(time) {
    this.timeConfig.to.value = time;
    this.onRangeChange({from: this.timeConfig.from.value, to: this.timeConfig.to.value})
  }

  setInvalidDates() {
    this.isInvalidDates = this.timeConfig.from.value >= this.timeConfig.to.value ||
      this.timeConfig.to.value <= this.timeConfig.from.value;
  }

  private setConfig(from, to) {
    this.timeConfig = {
      from: {
        date: from ? this.moment(from).toDate() : undefined,
        value: from ? this.moment(from).valueOf() : undefined
      },
      to: {
        date: to ? this.moment(to).toDate() : undefined,
        value: to ? this.moment(to).valueOf() : undefined
      }
    };
    this.setInvalidDates();
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozDatesTimeRange', {
    bindings: {
      from: '<',
      to: '<',
      timeOnly: '<?',
      hideDate: '<?',
      hideToTime: '<?',
      dateOnly: '<?',
      zoneId: '<?',
      isRow: '<?',
      ticks: '<?',
      isIgnoreTimezoneOffsetDiff: '<?',
      fromPlaceholder: '@?',
      toPlaceholder: '@?',
      onRangeChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-dates-time-range/bringoz-dates-time-range.html',
    controller: BringozDatesTimeRangeComponent
  });

